import React from "react";
import { useNavigate } from "react-router-dom";

const Navigationbar = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-black text-white w-full text-sm font-medium text-center sm:py-3 py-1">
      <p className="tracking-widest text-[8px] sm:text-[16px]">
        Note: Delivery service is available only in Bhubaneswar.
      </p>
    </div>
  );
};

export default Navigationbar;
